export default "__VITE_ASSET__CylWp2uh__"